import { Box } from "@material-ui/core";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import CssGroupButton from "src/components/Button/CssGroupButton";
import InfoIcon from "src/components/Icon/InfoIcon";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useUserAnalysisSelector } from "src/context/monitoring/userAnalysisContext";
import TopUserTable from "./TopUserTable";

const TYPE = {
  ALL: "all",
  BORROW: "borrow",
  DEPOSIT: "deposit",
};

export default function TopUserByTransaction() {
  const { pool } = useParams();
  const { fetchTopActiveWallets } = useUserAnalysisSelector((state) => state.fetch);

  const selector = useCallback((state) => {
    if (!state.topActiveWallets[pool]) return [];
    return state.topActiveWallets[pool];
  });
  const data = useUserAnalysisSelector(selector);
  const [type, setType] = useState(TYPE.ALL);

  useEffect(() => {
    fetchTopActiveWallets(pool);
  }, [pool]);

  const realData = useMemo(() => {
    if (data[type]) return data[type];
    return [];
  }, [type, data]);

  return (
    <PaperWrapper title="Top Users By Transaction Number" paperProps={{ style: { padding: "1rem 0rem 0.5rem 0rem" } }}>
      <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
        <CssGroupButton
          style={{ marginRight: "0.5rem" }}
          defaultValue={type == TYPE.ALL ? 0 : type == TYPE.BORROW ? 1 : 2}
          config={[
            { label: "All", onClick: () => setType(TYPE.ALL) },
            { label: "Borrow", onClick: () => setType(TYPE.BORROW) },
            { label: "Deposit", onClick: () => setType(TYPE.DEPOSIT) },
          ]}
        />
        <InfoIcon title="A list of users who make a large number of transactions (deposit, borrow, or all transaction types) in the last 3 months." />
      </Box>
      <TopUserTable data={realData} pool={pool} />
    </PaperWrapper>
  );
}
